import "./assets/styles/main.scss";
import App from "./App.svelte";
import utils from "./utils";
const bootstrap = () => {
    const componentName = (document.currentScript &&
        document.currentScript.getAttribute("component-name")) ||
        "FloodMap";
    window[componentName] = App;
};
// If it is in iframe run app
if (utils.inIframe() ||
    window.location.origin.includes("localhost") ||
    window.location.origin.includes("ngrok")) {
    bootstrap();
}
else {
    const pathName = process.env.PRODUCTION
        ? process.env.PROD_PATHNAME
        : process.env.DEV_PATHNAME;
    window.location.replace(`${window.location.origin}/${pathName}${window.location.search}`);
}
export default App;
